import * as pathUtil from 'path'

class Dot {
  static TYPE = {
    TEXT: 'text',
    IMAGE: 'image'
  }

  constructor(resource) {
    this.resource = resource
    switch (this.resource.ext) {
      case '.txt':
      this.dotType = Dot.TYPE.TEXT
      break
      case '.png':
      case '.jpg':
      case '.jpeg':
      this.dotType = Dot.TYPE.IMAGE
      break
      default:
      console.warn(`Unsupported ext: ${this.resource.ext}`)
    }
  }

  imageUrl() {
    return this.resource.absoluteUrl
  }

  text(handler) {
    this.resource.loadText(handler)
  }

  textPromise() {
    return new Promise((resolve, reject) => {
      this.resource.loadText(text => resolve(text))
    })
  }
}

class ConnectedDot {
  constructor() {
    this.dots = []
  }

  bad_collectionId() {
    const dot = this.dots[0]
    const collectionFilename = dot.resource.path.split(pathUtil.sep)[1]
    return pathUtil.basename(collectionFilename, ".webdotplate")
  }
}

export { Dot, ConnectedDot }


// WEBPACK FOOTER //
// ./src/Domain/Dot.js